module.exports = __webpack_public_path__ + "img/placeholder/evang-info-bg.svg";